import React from 'react';

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5714 18.5714V11.4286H17.1429V18.5714H14.2857V1.42857H12.8571V18.5714H5.71429V8.57143H4.28571V18.5714H1.42857V0H0V18.5714C0.000378198 18.9502 0.151009 19.3133 0.418837 19.5812C0.686664 19.849 1.04981 19.9996 1.42857 20H20V18.5714H18.5714Z" fill="currentColor" />
    <path d="M8.57129 1.42859H9.99986V11.4286H8.57129V1.42859Z" fill="#FF6F91" />
  </svg>

);
